import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, salaryStepsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, salaryStepsActions);

export default slice.reducer;
